import { urls } from '../constants';
import { Put, Get } from '../fetch';
export async function updateSettings(body) {
  return Put(urls.tenants.accountSettings.v1, body);
}
export async function getSettings() {
  return Get(urls.tenants.accountSettings.v1);
}